import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const WarningIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 11 10" {...props}>
      <path d="M10.8553 8.26058L6.50822 0.622114C6.3095 0.261926 5.93689 0.0507812 5.50218 0.0507812C5.06747 0.0507812 4.70728 0.261926 4.49614 0.622114L0.149043 8.26058C-0.0496811 8.62077 -0.0496811 9.05548 0.149043 9.41566C0.347768 9.77585 0.720376 9.987 1.14266 9.987H9.82443C10.2467 9.987 10.6193 9.77585 10.8181 9.41566C11.054 9.05548 11.054 8.62077 10.8553 8.26058ZM6.13561 8.17364H4.98053V7.1676H6.13561V8.17364ZM6.13561 6.58384H4.98053V3.70234H6.13561V6.58384Z" />
    </SvgIcon>
  );
});
